import { render, staticRenderFns } from "./PopupCouponExchangeSuccess.vue?vue&type=template&id=5e54c72a&scoped=true&"
import script from "./PopupCouponExchangeSuccess.vue?vue&type=script&lang=js&"
export * from "./PopupCouponExchangeSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PopupCouponExchangeSuccess.vue?vue&type=style&index=0&id=5e54c72a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54c72a",
  null
  
)

export default component.exports